import type {
	CustomItem,
	DropSpinsFormatType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropSpinsFormat = (
	item: Item | CustomItem
): item is DropSpinsFormatType => {
	return !!(
		item &&
		item.__typename === 'Drop_Custom_Component' &&
		item.name === 'Spins_Format'
	);
};
